import { render, staticRenderFns } from "./honorqualification.vue?vue&type=template&id=05eac20d&scoped=true&"
import script from "./honorqualification.vue?vue&type=script&lang=js&"
export * from "./honorqualification.vue?vue&type=script&lang=js&"
import style0 from "./honorqualification.vue?vue&type=style&index=0&id=05eac20d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eac20d",
  null
  
)

export default component.exports